
import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function ProgramsIcon(props) {
    const { selected } = props;
    const classes = useStyles({selected, ...props})()

    return(
        <svg className={classes.container}  width="21" height="24" viewBox="0 0 23 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.6923 1.75H5.30769C5.07308 1.75 4.84807 1.65781 4.68217 1.49372C4.51628 1.32962 4.42308 1.10706 4.42308 0.875C4.42308 0.642936 4.51628 0.420376 4.68217 0.256282C4.84807 0.0921874 5.07308 0 5.30769 0H17.6923C17.9269 0 18.1519 0.0921874 18.3178 0.256282C18.4837 0.420376 18.5769 0.642936 18.5769 0.875C18.5769 1.10706 18.4837 1.32962 18.3178 1.49372C18.1519 1.65781 17.9269 1.75 17.6923 1.75ZM19.4615 4.375H3.53846C3.30385 4.375 3.07884 4.28281 2.91294 4.11872C2.74705 3.95462 2.65385 3.73206 2.65385 3.5C2.65385 3.26794 2.74705 3.04538 2.91294 2.88128C3.07884 2.71719 3.30385 2.625 3.53846 2.625H19.4615C19.6962 2.625 19.9212 2.71719 20.0871 2.88128C20.253 3.04538 20.3462 3.26794 20.3462 3.5C20.3462 3.73206 20.253 3.95462 20.0871 4.11872C19.9212 4.28281 19.6962 4.375 19.4615 4.375ZM20.5192 21H2.48079C1.82307 20.9993 1.1925 20.7405 0.727416 20.2805C0.262335 19.8205 0.000731698 19.1967 0 18.5462V7.70383C0.000731698 7.05325 0.262335 6.42953 0.727416 5.96951C1.1925 5.50948 1.82307 5.25072 2.48079 5.25H20.5192C21.1769 5.25072 21.8075 5.50948 22.2726 5.96951C22.7377 6.42953 22.9993 7.05325 23 7.70383V18.5462C22.9993 19.1967 22.7377 19.8205 22.2726 20.2805C21.8075 20.7405 21.1769 20.9993 20.5192 21Z" fill="#2196C0"/>
        </svg>
    )
}

const useStyles = ({selected, ...props}) => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: selected ? "#FFF" : theme.palette.secondary.main,
            width: props.width,
         },
    }
}));